import React, { useEffect, useRef, useState } from 'react'
import { Box, Flex, List, ListItem, Menu, MenuButton, MenuItem, MenuList, Spacer, useDisclosure, Tooltip, Button } from "@chakra-ui/react"
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom';
import { replaceurlbystore, ShopifyStoreFrontAccessToken, ShopifyStoreLink } from "../../../GlobalVar";
// import {useQuery} from "react-query";
// import {shopifyAxios} from "../../apiClients/shopifyClient";
import { scrollToTop } from "../../utils";
import { useNavigate } from "react-router-dom";
import {useQuery} from "react-query";
import {shopifyAxios} from "../../apiClients/shopifyClient";

export function MenuNavigation() {
    const overflowref = useRef(null);
    const { isOpen, onOpen, onClose } = useDisclosure()
    const drillClubRef = useRef(null);
    const helpRef = useRef(null);
    // const navigate = useNavigate();
    const {isOpen: isDrillClubOpen, onOpen: onDrillClubOpen, onClose: onDrillClubClose} = useDisclosure()
    const { isOpen: isHelpOpen, onOpen: onHelpOpen, onClose: onHelpClose } = useDisclosure()
    const overlayRef = useRef(null);
    const [show, setShow] = useState(false);
    const [Index, setIndex] = useState(0)
    const [Index2, setIndex2] = useState(0)
    const [menus, setMenus] = useState('')
    const [childshow, setChildshow] = useState(0);
    const coBrowsingInstance = window.coBrowsingInstance;
    const submenuRefs = useRef({})
    const checkoverflow = () => {
        if (overflowref.current.scrollHeight > overflowref.current.clientHeight) {
            overflowref.current.querySelector('.viewmore-btn')
            if (overflowref.current.querySelector('.viewmore-btn') == null) {

                const spant = document.createElement('span');
                spant.textContent = 'Scroll for More';
                spant.style.height = "65px !important";
                spant.className = 'viewmore-btn';
                overflowref.current.appendChild(spant)

            }

        }
    }



    const checkSubmenusOverflow = () => {
        Object.keys(submenuRefs.current).forEach((key) => {
            const submenu = submenuRefs.current[key];
            if (submenu && submenu.scrollHeight > submenu.clientHeight) {
                if (submenu.querySelector('.viewmore-btn') == null) {
                    const spanu = document.createElement('span');
                    spanu.textContent = 'Scroll for More';
                    spanu.style.height = "65px !important";
                    spanu.className = 'viewmore-btn';
                    submenu.appendChild(spanu)
                }
            } else if (submenu) {
                const e = submenu.querySelector('.viewmore-btn')
                if (e != null) {
                    submenu.removeChild(e);
                }
            }
        })
    }

    useEffect(() => {
        getMenu();
    }, [])


    const Menuhover = (index, index2, child) => {
        setIndex(index);
        setShow(true)
        if (index2) {
            setIndex2(index2);
        } else {
            setIndex2(0);
        }
        setChildshow(child);
    }

    const screenlock = () => {
        var element = document.getElementById('screenlock');
        element?.classList?.add('scrolllock');
    }

    const overlayOpen = () => {
        overlayRef.current.classList.add('overlaybody');

    }

    const overlayRemove = () => {
        overlayRef.current.classList?.remove('overlaybody');
    }

    const AllClose = () => {
        setShow(false);
        setChildshow(0)
        onClose()
        Active(0)
        var element = document.getElementById('screenlock');
        element?.classList?.remove('scrolllock');
        overlayRemove()
    }

    const Active = (item1, item2) => {
        if (item1 === item2) {
            return 'active';
        }
        if (item1 === 0) return null
    }

    const getMenu = () => {
        const query = `query {
        menu(handle: "shop-products") {
           items {
            title
            url
            items {
              title
              url
              items {
                title
                url
              }
            }
          }
        }
       }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    setMenus(values[0]['data']['menu']['items']);
                });

            })
    }

    const {data: drillClub360} = useQuery('drillclub-360', () => {
        const query = `{
        menu(handle: "drillclub-360") {
           items {
            title
            url
            items {
              title
              url
              items {
                title
                url
              }
            }
          }
        }
       }`;
        return shopifyAxios.post('', query);
    }, {
        refetchOnWindowFocus: false, select: res => {
            return res.data?.data?.menu?.items;
        }
    });

    const getLastPart = (url) => {
        const replacedUrl = url.replace(`${replaceurlbystore}`, '');
        return replacedUrl.split('/').pop();
    }


    function isProductUrl(url) {
        const replacedUrl = url.replace(`${replaceurlbystore}`, '');
        const splits = replacedUrl.split('/');
        splits.pop();
        const secondLastPart = splits.pop();
        return secondLastPart.toLowerCase() === 'products';
    }

    const navigate = useNavigate();

    const handleCollections = () => {
        navigate(`/collections`)
    }


    return (<Flex pos={"sticky"} top="0" zIndex="100" display={{ base: "none", md: "block" }}
        bg='gray.100' fontSize='17px' fontWeight='bold' textAlign='left' className='main_menu_mt_home'
        backgroundColor="#F2F2F2">
        <div className="abc" id="overlay" ref={overlayRef} />
        <Box className='main_container'>
            {/*<ShopProductsMenu overlayRef={overlayRef}/>*/}
            <Menu isOpen={isOpen}>
                <MenuButton
                    variant="ghost"
                    py={[1, 2, 2]}
                    px={4}
                    borderRadius={5}
                    _hover={{ color: '#592C82 !Important' }}
                    aria-label="Shop Products"
                    fontWeight="normal"
                    onMouseEnter={() => {
                        onOpen();
                        overlayOpen();
                    }}
                    onMouseLeave={() => {
                        onClose();
                        overlayRemove();
                    }}

                    onClick={() => handleCollections()}
                    className='main_menu_items_mt menu_item'
                >
                    Shop Products {isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
                </MenuButton>
                {/* <div className={isOpen?"layer":"layer2"}></div> */}
                <MenuList p={0} onMouseEnter={() => {
                    onOpen();
                    screenlock();
                    overlayOpen()
                    checkoverflow();
                }} onMouseLeave={() => {
                    AllClose();
                    overlayRemove()
                }}
                    className='menu_open_mt'>
                    <div className='Default_height_set ' ref={overflowref}>
                        <Flex className='chiled_header' bg="white"> <Link to='/collections' onClick={onClose} style={{ cursor: "pointer" }}><span
                            style={{ fontSize: "20px" }}>CATEGORIES</span>
                        </Link> <Spacer />
                            <Link to='/collections' onClick={onClose} style={{ color: '#EC7700', cursor: "pointer" }}>View
                                all</Link></Flex>
                        {menus && menus.map((menu, i) => {
                            let Heading = menus[Index];
                            let subHeading = menus[Index].items[Index2];

                            return (<React.Fragment key={menu.url + '-' + i}>
                                <MenuItem
                                    className={Active(menu.title, menus[Index].title)}
                                    onMouseEnter={() => {
                                        Menuhover(i);
                                        checkSubmenusOverflow();
                                    }}
                                    onClick={() => {
                                        // Navigate to the `/collections` page
                                        console.log("clicked---------------------")
                                        AllClose();
                                        const lastPart = getLastPart(Heading.url);
                                        navigate(`/collections/${lastPart}`);
                                    }}
                                >
                                    {menu.title}
                                    <Spacer />
                                    <ChevronRightIcon />
                                </MenuItem>
                                {
                                    show ? <List p={0}
                                        borderLeft='5px solid #592C82'
                                        className='chiled_open_mt'>
                                        < div className='Default_height_set' ref={(node) => {
                                            submenuRefs.current[`${i}`] = node
                                        }}>
                                            <Flex className='chiled_header' bg="white"><Link to={`/collections/${getLastPart(Heading.url)}`}
                                                onClick={AllClose}
                                                style={{ cursor: "pointer" }}><span
                                                    style={{ fontSize: "20px" }}>{Heading.title}</span></Link> <Spacer />
                                                <Link to={`/collections/${getLastPart(Heading.url)}`}
                                                    onClick={AllClose}
                                                    style={{ color: '#EC7700', cursor: "pointer" }}>View
                                                    all</Link>
                                            </Flex>
                                            <Box className='scrollY'>
                                                {menus[Index].items.map((child, index) => {
                                                    // console.log(child);
                                                    let itemUrl = `/collections/${getLastPart(Heading.url)}/${getLastPart(child.url)}`;
                                                    if (isProductUrl(child.url)) {
                                                        itemUrl = `/products/${getLastPart(child.url)}`;
                                                    }
                                                    return (<React.Fragment key={child.url + '-' + index}>
                                                        {child.items.length === 0 ?
                                                            <Link
                                                                to={itemUrl}>
                                                                <ListItem
                                                                    cursor={"pointer"}
                                                                    onClick={onClose}
                                                                    className={'dropdown_menu_list linkHover ' + Active(child.title, subHeading.title)}
                                                                    onMouseEnter={() => Menuhover(Index, index, child.items.length, Heading.url, child.url)}
                                                                >
                                                                    {child.title}
                                                                </ListItem>
                                                            </Link>
                                                            : <>
                                                                <ListItem
                                                                    cursor={"pointer"}
                                                                    // onClick={onClose}
                                                                    onClick={() => {
                                                                        // Navigate to the `/collections` page
                                                                        console.log("clicked---------------------");
                                                                        AllClose();
                                                                        const lastPart = getLastPart(child.url);
                                                                        const parentPart = getLastPart(Heading.url);
                                                                        navigate(`/collections/${parentPart}/${lastPart}`);
                                                                    }}
                                                                    className={'dropdown_menu_list linkHover ' + Active(child.title, subHeading.title)}
                                                                    onMouseEnter={() => Menuhover(Index, index, child.items.length, Heading.url, child.url)}>
                                                                    {child.title}
                                                                    <Spacer />
                                                                    <ChevronRightIcon />
                                                                </ListItem>
                                                            </>}
                                                    </React.Fragment>)
                                                })}
                                                <ListItem visibility={"hidden"} className={"menuextraItem"} minH={"50px"}
                                                    maxH={"60px"}> </ListItem>
                                            </Box>
                                        </div>
                                        {
                                            childshow > 0 ? <List p={0} borderLeft='5px solid #592C82'
                                                className='chiled_open_mt-2'>
                                                <div className='Default_height_set'>
                                                    <Flex className='chiled_header' bg="white"> <Link
                                                        to={`/collections/${getLastPart(Heading.url)}/${getLastPart(subHeading.url)}`}
                                                        onClick={AllClose}
                                                        style={{ cursor: "pointer" }}><span
                                                            style={{ fontSize: "20px" }}>{subHeading.title}</span></Link><Spacer />
                                                        <Link
                                                            to={`/collections/${getLastPart(Heading.url)}/${getLastPart(subHeading.url)}`}
                                                            onClick={AllClose}
                                                            style={{ color: '#EC7700', cursor: "pointer" }}>View
                                                            all</Link>
                                                    </Flex>
                                                    {subHeading.items.map((subchild, index) => {
                                                        // console.log("Sub heading items = ", subHeading);
                                                        let url = subchild.url;
                                                        let itemUrl = `/collections/${getLastPart(Heading.url)}/${getLastPart(subHeading.url)}/${getLastPart(url)}`;
                                                        if (isProductUrl(url)) {
                                                            itemUrl = `/products/${getLastPart(url)}`;
                                                        }
                                                        return (<Link onClick={onClose} key={subchild.url + '-' + index}
                                                            to={itemUrl}>
                                                            <ListItem
                                                                className={"dropdown_menu_list"}>{subchild.title}</ListItem>
                                                        </Link>)
                                                    })}
                                                </div>
                                            </List> : null
                                        }
                                    </List> :
                                        null
                                }
                            </React.Fragment>)
                        })}
                        <MenuItem visibility={"hidden"} className={"menuextraItem"} minH={"50px"} maxH={"60px"}> </MenuItem>
                    </div>
                </MenuList>
            </Menu >
            <Button
                as={Link}
                to='/our-brands'
                onClick={scrollToTop}
                variant="ghost"
                mx={1}
                py={[1, 2, 2]}
                _hover={{ color: '#592C82 !Important' }}
                px={4}
                borderRadius={5}
                aria-label="Shop Brands"
                fontWeight="normal"
                className='main_menu_items_mt menu_item'
            >Shop Brands</Button>
            <Menu isOpen={isDrillClubOpen}>
                <MenuButton
                    variant="ghost"
                    mx={1}
                    py={[1, 2, 2]}
                    px={4}
                    borderRadius={5}
                    _hover={{color: '#592C82 !Important'}}
                    ref={drillClubRef}
                    aria-label="DRILLCUT 360"
                    fontWeight="normal"
                    className='main_menu_items_mt menu_item'
                    onMouseEnter={() => {
                        onDrillClubOpen();
                        overlayOpen()
                    }}
                    onMouseLeave={() => {
                        onDrillClubClose();
                        overlayRemove()
                    }}
                    onClick={() => {
                        scrollToTop();
                        navigate('/pages/360')
                    }}
                >DRILLCUT 360 {isDrillClubOpen ? <ChevronDownIcon/> : <ChevronRightIcon/>} </MenuButton>
                <MenuList
                    style={{left: drillClubRef?.current?.offsetLeft, width: "315px"}}
                    onMouseEnter={() => {
                        onDrillClubOpen();
                        // screenlock();
                        overlayOpen()
                    }}
                    onMouseLeave={() => {
                        onDrillClubClose();
                        overlayRemove()
                    }}
                    className='menu_open_mt'>
                    {drillClub360?.map((drillClub) => {
                        const replacedUrl = drillClub?.url?.replace(replaceurlbystore, '');
                        // console.log(replacedUrl);
                        if (!replacedUrl.startsWith('https://')) {
                            return <MenuItem key={drillClub?.url} as={Link} to={replacedUrl} onClick={scrollToTop}>{drillClub?.title}</MenuItem>
                        } else {
                            return <Tooltip key={drillClub?.url} label="opens in new tab" fontSize="md" placement='top'>
                                <MenuItem as="a" href={replacedUrl} target="_blank"
                                   rel="noreferrer" aria-label={`${drillClub?.title} (opens in new tab)`}>{drillClub?.title}</MenuItem>
                            </Tooltip>
                        }
                    })}
                </MenuList>
                {/*</Link>*/}
            </Menu>
            {/*<Menu>*/}
            {/*    <Link to='/drillclub' onClick={scrollToTop}>*/}
            {/*        <MenuButton*/}
            {/*            variant="ghost"*/}
            {/*            mx={1}*/}
            {/*            py={[1, 2, 2]}*/}
            {/*            px={4}*/}
            {/*            borderRadius={5}*/}
            {/*            _hover={{color: '#592C82 !Important'}}*/}
            {/*            aria-label="Courses"*/}
            {/*            fontWeight="normal"*/}
            {/*            className='main_menu_items_mt menu_item'*/}
            {/*        >DRILLClub<ChevronRightIcon/></MenuButton></Link>*/}
            {/*</Menu>*/}
            <Button
                as={Link}
                to='/downloads'
                onClick={scrollToTop}
                variant="ghost"
                mx={1}
                py={[1, 2, 2]}
                px={4}
                borderRadius={5}
                _hover={{ color: '#592C82 !Important' }}
                aria-label="Downloads"
                fontWeight="normal"
                className='main_menu_items_mt menu_item'
            >Downloads</Button>
            <Button
                as={Link}
                to='/drillcut-tv'
                onClick={scrollToTop}
                variant="ghost"
                mx={1}
                py={[1, 2, 2]}
                px={4}
                borderRadius={5}
                _hover={{ color: '#592C82 !Important' }}
                aria-label="DRILLCUT TV"
                fontWeight="normal"
                className='main_menu_items_mt menu_item'
            >DRILLCUT TV
            </Button>
            <Button
                as={Link}
                to='/news-and-learning'
                onClick={scrollToTop}
                variant="ghost"
                mx={1}
                py={[1, 2, 2]}
                px={4}
                borderRadius={5}
                _hover={{ color: '#592C82 !Important' }}
                aria-label="News And learning"
                fontWeight="normal"
                className='main_menu_items_mt menu_item'
            >News And learning
            </Button>
            <Menu isOpen={isHelpOpen}>
                <MenuButton
                    variant="ghost"
                    mx={1}
                    py={[1, 2, 2]}
                    px={4}
                    borderRadius={5}
                    _hover={{ color: '#592C82 !Important' }}
                    ref={helpRef}
                    aria-label="Help"
                    fontWeight="normal"
                    className='main_menu_items_mt menu_item'
                    onMouseEnter={() => {
                        onHelpOpen();
                        overlayOpen()
                    }}
                    onMouseLeave={() => {
                        onHelpClose();
                        overlayRemove()
                    }}
                >Help {isHelpOpen ? <ChevronDownIcon /> : <ChevronRightIcon />} </MenuButton>
                <MenuList
                    style={{ left: helpRef?.current?.offsetLeft, width: "315px" }}
                    onMouseEnter={() => {
                        onHelpOpen();
                        overlayOpen()
                    }}
                    onMouseLeave={() => {
                        onHelpClose();
                        overlayRemove()
                    }}
                    className='menu_open_mt'>
                    <Tooltip label="opens in new tab" fontSize="md" placement='top'>
                        <MenuItem as="a" href="https://support.drillcut.au/" target="_blank" rel="noreferrer" aria-label="Help Centre (opens in new tab)">Help
                            Centre</MenuItem>
                    </Tooltip>
                    {coBrowsingInstance && <MenuItem onClick={() => {
                        coBrowsingInstance.showPopup();
                    }}>Co Browse</MenuItem>}
                </MenuList>
            </Menu>
        </Box >
    </Flex >)
}
